export default __webpack_public_path__ + "static/nhrc-467a80cf1f75330a28924b7ce51433fb.png";